export default "__VITE_PUBLIC_ASSET__df1da319__"